export default "__VITE_PUBLIC_ASSET__2b0123ac__"